/* eslint-disable */
/**
 * The path of the `ProfilePage` to be consumed by a `<Router />`
 * @export
 */
export const PROFILE_PAGE_PATH = `/profile`;

/**
 * Create a `href` that will resolve to `ProfilePage`
 * @export
 * @returns {string} The `PROFILE_PAGE_PATH`
 */
export const createProfilePageLink = () => PROFILE_PAGE_PATH;

/**
 * Determine if the current page is the `ProfilePage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `ProfilePage`
 */
export const isProfilePage = (match) => match.path === PROFILE_PAGE_PATH;
